import React, { useMemo } from "react"

import { connect } from "scrivito"
import {
  NotificationContext,
  NotificationContextType,
  NotificationType
} from "shared/context/NotificationContext"
import { useDebounce } from "shared/lib/performance/useDebounce"

import { getPrimaryPortalNewsPage } from "entities/portal-news/api/getPrimaryPortalNewsPage"
import { usePortalNewsListData } from "entities/portal-news/model/usePortalNewsListData"
import { useTeamInvitationListData } from "entities/team-invitations/model/useTeamInvitationListData"

interface NotificationProviderProps {
  children: React.ReactNode | React.ReactNode[]
}

function NotificationProviderComponent({
  children
}: NotificationProviderProps) {
  const { unreadPostIDs } = usePortalNewsListData({
    page: getPrimaryPortalNewsPage()
  })
  // Debounce for 400ms to avoid hydration issues
  const debouncedUnreadPostIDs = useDebounce(unreadPostIDs, 400, [])

  const { teamInvitations } = useTeamInvitationListData()

  const context = useMemo<NotificationContextType>(
    () => ({
      [NotificationType.PORTAL_NEWS]: debouncedUnreadPostIDs.length,
      [NotificationType.PROJECT_TEAM_INVITATIONS]: teamInvitations.length
    }),
    [debouncedUnreadPostIDs, teamInvitations]
  )

  return (
    <NotificationContext.Provider value={context}>
      {children}
    </NotificationContext.Provider>
  )
}

export const NotificationProvider = connect(NotificationProviderComponent)
